import React, { useState, useEffect } from 'react'
import Card from "../components/Card";
import Pagination from "../components/layout/Pagination";
import { useLocation } from 'react-router-dom';
import Spinner from '../components/layout/Spinner'
import { Helmet } from 'react-helmet';


function AdditiveList() {
    const [additives, setAdditives] = useState([])
    const [loading, setLoading] = useState(true)
    const location = useLocation()
    const [manufacturer, setManufacturer] = useState(null);  // филтер за марка на масло
    const [sortBy, setSortBy] = useState("");
    const [hasLoadedManufacturer, setHasLoadedManufacturer] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL;

    const [totalItems, setTotalItems] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    const [pageSize, setPageSize] = useState(8);
    const [currentPage, setCurrentPage] = useState(1);

    const queryParams = new URLSearchParams(location.search);
    const manufacturerFromUrl = queryParams.get('manufacturer') == null ? "" : queryParams.get('manufacturer')

    useEffect(() => {
        setManufacturer(manufacturerFromUrl);
        setHasLoadedManufacturer(true);

    }, [manufacturerFromUrl]);

    useEffect(() => {
        if (hasLoadedManufacturer) {
            fetchAdditives();
        }
    }, [manufacturer, sortBy, currentPage]);

    const fetchAdditives = async () => {
        try {
            setLoading(true)

            const response = await fetch(`${API_URL}/Item/additives?&manufacturer=${manufacturer}&sortBy=${sortBy}&pageNumber=${currentPage}&pageSize=${pageSize}`)

            const result = await response.json()
            if (result?.data?.items) {
                setAdditives(result.data.items);
                //setTotalItems(result.data.totalItems);
                setTotalPages(result.data.totalPages)
                setLoading(false)
            } else {
                setAdditives([]);
                setLoading(false)
            }
        }
        catch (error) {
        }
    }

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const pageTitle = manufacturer ? `${manufacturer} Адитиви за Гориво - Купи Онлајн` : "Адитиви за Гориво - Купи Онлајн";
    const pageDescription = manufacturer 
        ? `Купи адитиви за гориво од брендот ${manufacturer}. Погледни ги нашите адитиви кои имаат најдобри цени.`
        : "Погледни ги најдобрите адитиви за гориво на пазарот по најдобри цени.";
    const pageKeywords = manufacturer 
        ? `${manufacturer}, адитиви за гориво, чистење дизни, чистење турбо, чистење DPF`
        : "адитиви за гориво, адитив за чистење дизни, адитив за чистење турбо, адитив за чистење DPF";


    if (loading) {
        return <Spinner />
    }


    return (
        <div className='flex flex-col justify-start items-center'>

             <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
                <meta name="keywords" content={pageKeywords} />
            </Helmet>

            <div>
                <h1 className='text-4xl font-bold mb-8 text-center'>Адитиви</h1>
            </div>
            <div className='ml-auto'>
                <select
                    className="mr-4 select select-xs"
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                >
                    <option value="">Основно</option>
                    <option value="price_asc">Цена (растечки)</option>
                    <option value="price_desc">Цена (опаѓачки)</option>
                    <option value="createdate">Најново додадено</option>
                </select>
            </div>
            <div className="flex flex-wrap justify-center ">
                <div className="child p-2 w-full sm:w-auto">
                    <select
                        value={manufacturer ?? ""}
                        onChange={(e) => setManufacturer(e.target.value)}
                        className='mt-2 select select-sm'
                    >
                        <option value="">Сите брендови</option>
                        <option value="Wynn's">Wynns</option>
                        <option value="STP">STP</option>
                    </select>
                </div>
            </div>
            <div
                className={`grid gap-4 mt-[5%] text-xl ${additives.length === 1 ? 'grid-cols-1 justify-center' : additives.length === 2 ? 'grid-cols-2 justify-center' : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'
                    }`}
            >
                {additives.length === 0 ? (
                    <p>Нема адитив за прикажување според избраните критериуми.</p>
                ) : (
                    additives.map((additive) => (
                        <Card key={additive.id} item={additive} className='mr-4 mb-4' />
                    ))
                )}
            </div>
            {additives.length > 0 && (
                <><div>Тековна страна: {currentPage}</div>
                    <Pagination
                        totalPages={totalPages}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                    /></>
            )}
        </div>
    )
}

export default AdditiveList
